import React,{ useRef } from 'react';
import { 
    Show,
    SimpleShowLayout,
    ListButton,
    CardActions
} from 'react-admin';
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import SamplePrint from './ChecklistPrint'
import { Redirect } from 'react-router-dom';

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px 30px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '700px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },

    body :{
        display: 'inline-block', 
        margin: '5px 20px 5px 35px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '700px',
        alignItems: 'middle',
        border: '0',
        fontSize: '12px',
        textAlign: 'left'
    },
    p: {
        fontSize: '12px',
    },
    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
        marginTop: '1em',
        marginLeft: '30px',
        marginBottom: '1em',
       
    }
})

var uid = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const SampleActions = ({basePath}) => (
    <CardActions style={cardActionStyle}>
        <ListButton  
        label='List' 
        basePath={'/checklist?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
        />
    </CardActions>
);

const GetKey=({ record }) => (
    console.log(record),
    uid = (record.uid)? record.uid:uid,
    (uid)? '': <Redirect to="/userslist" />
);

const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <SamplePrint record={record} classes={classes} ref={componentRef} />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };


const CheckListShow= ({ classes, ...props }) => (
    <Show
    {...props}
    /* disable the app title change when shown */
    title="Sample View "
    actions={<SampleActions />} 
    >
    <SimpleShowLayout>
    <GetKey props={props} />
    <Print />
    </SimpleShowLayout>
</Show>
)

export default CheckListShow

/*

import React , { useRef } from 'react';
import {
    Show,
    SimpleShowLayout,
    CardActions,
    ListButton
} from 'react-admin';
//import { Checkmark } from 'react-checkmark'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import { TextField } from '@material-ui/core';

const useStyles = makeStyles({
    root: {  
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: "775px",
        maxWidth: '800',            
        alignItems: 'middle',
        margin: "20px 10px 2px 20px",  
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px -10px', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },
    p: {
        fontSize: '12px',
    },
    p2: {
        fontSize: '9px',
        textAlign: 'right'
    },
})

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
  };

var questions = [];
var answers=[]

const ExamActions = ({basePath, ...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} label="History List" />
    </CardActions>
  );
  

  
const Heading=({data})=>{
    return (<h3>{data}</h3>)
}



const Contents =({data, ftype})=>{
    console.log(data)

    var queue = [];

    if(!data) return null;
    
    for(var i=1;  i < (eval(`data.${ftype}_count`) + 1); i++){

        queue.push(<tr >
                    <td style={{fontWeight:'bold'}}> {eval(`data.${ftype}_proced_${i}`)} </td>
                    <td>{eval(`data.${ftype}_referance_${i}`)} </td>
                    <td>{eval(`data.${ftype}_introduced_date_${i}`)} </td>
                    <td>{eval(`data.${ftype}_trainer_init_${i}`)} </td>
                    <td>{eval(`data.${ftype}_trainee_init_${i}`)} </td>
                    <td>{eval(`data.${ftype}_proficient_date_${i}`)} </td>
                </tr>)
       }
    
    return(
      {queue}
    )
}


const CheckListShow = ({...props }) => (
    <Show  
       
        actions={<ExamActions />}
        {...props}
        title=""
    >

        <SimpleShowLayout>
        <table style={{width:"99%", fontSize: "11px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}> 
                                    Training and Education Procedures
                                </td>
                            </tr>
                            <tr>
                                <td ><Heading  data={props.record && props.record.name} /></td>
                            </tr>
                           
                            </tbody>
                            </table>
                        </td>                  
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}><TextField  source="trainee" label="" /></td>
                <td>&nbsp;Center:</td><td style={{width:"35%", border: "1px solid", cellSpacing:"10"}}><TextField  source="content1_proced_1" label="" /></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer1}</td>
                <td>&nbsp;Initial:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer1_init}</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer2}</td>
                <td>&nbsp;Initial:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer2_init}</td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer3}</td>
                <td>&nbsp;Initial:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainer3_init}</td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Reference</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Introduce</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainer Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Proficient</th>
                            </tr>
                            <Contents data={props.record} ftype='content1' />
                            <tr>
                                <td colSpan="6" style={{backgroundColor: "silver", fontWeight: "bold", textAlign: "center"}}><Heading  data={props.record && props.record.sub_heading} /></td>
                            </tr>
                            <Contents data={props.record} ftype='content2' />
                        </tbody>
                    </table>
            
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Signature:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainee_sign}</td>
                <td>&nbsp;Date:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.trainee_sign_date}</td>
            </tr>
            <tr>
                <td>Center Manager Signature:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.mgr_sign}</td>
                <td>&nbsp;Date:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.mgr_sign_date}</td>
            </tr>
            <tr>
                <td>Quality Assurance Signature:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.qa_sign}</td>
                <td>&nbsp;Date:</td><td style={{width:"35%", border: "1px solid",cellSpacing:"10" }}>{props.record && props.record.qa_sign_date}</td>
            </tr>
            </tbody>
        </table>
        </SimpleShowLayout>
    </Show>
)

export default CheckListShow;

*/